import Navbar from "react-bootstrap/Navbar";
import { Button } from "@mui/material";
import noImage from "../../images/No_Image_Available.jpg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setMobileBackColor, setMobileTextColor } from "../../utility";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useEffect, useState } from "react";
import no_image from "../../images/No_Image_Available.jpg";
import { Badge, Container } from "react-bootstrap";
import { t } from "i18next";
import {
  ArrowBackOutlined,
  ArrowForwardOutlined,
  ArrowRightOutlined,
} from "@mui/icons-material";

const TopNav = ({
  openBar,
  logo,
  venueName,
  handleParent,
  backToMain,
  width,
  cover,
  desc,
  label_name,
  tableName,
  tableQr,
}) => {
  const [params, setParams] = useSearchParams();
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  const onImageError = (e) => {
    e.target.src = noImage;
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleBack = () => {
    if (params.get("section")) {
      navigate(
        `/${tableName}/${tableQr}/sections?section=${params.get(
          "section"
        )}&t=${params.get("t")}&lang=${localStorage.getItem("lang")}`
      );
    } else {
      navigate(
        `/${tableName}/${tableQr}/sections?section=0&t=${params.get(
          "t"
        )}&lang=${localStorage.getItem("lang")}`
      );
    }
  };

  return (
    <>
      <div>
        <div className="slider-mobile">
          <img
            src={cover ? cover : no_image}
            onError={onImageError}
            className="slider-mobile-image"
          />
          <Navbar
            className={`d-flex justify-content-between align-items-center mobile-top-nav alignByLang`}
            style={{
              backgroundColor:
                localStorage.getItem("theme") === "dark" ||
                  localStorage.getItem("theme") === "customize"
                  ? setMobileBackColor()
                  : "",
            }}
          >
            {!isScrolled && !window.location.pathname.includes("/labels") && (
              <Button sx={{ color: setMobileTextColor() }} onClick={openBar}>
                <MenuOutlinedIcon />
              </Button>
            )}
            {window.location.pathname.includes("/labels") && (
              <Button
                variant="text"
                className={`ms-2 dark-color cursor`}
                style={{ color: setMobileTextColor() }}
                onClick={() => handleBack()}
              >
                {params.get("lang") === "ar" || params.get("lang") === "fa" ? (
                  <ArrowForwardOutlined sx={{ color: setMobileTextColor() }} />
                ) : (
                  <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                )}
              </Button>
            )}


            <Navbar.Brand className="text-center">
              {logo ? (
                <img
                  src={logo || no_image}
                  className="me-4 slider-mobile-logo"
                  onError={onImageError}
                />
              ) : (
                <img
                  src={no_image}
                  className="me-4 slider-mobile-logo"
                  onError={onImageError}
                />
              )}
            </Navbar.Brand>
            {params.get("section") != 0 && !isScrolled ? (
              <Button
                onClick={handleParent}
                style={{ color: setMobileTextColor(), zIndex: 1 }}
              >
                {params.get("lang") === "ar" || params.get("lang") === "fa" ? (
                  <ArrowBackOutlinedIcon
                    className={`${params.get("section") != 0 ? "" : "d-none"}`}
                    sx={{ color: setMobileTextColor() }}
                  />
                ) : (
                  <ArrowForwardOutlined
                    className={`${params.get("section") != 0 ? "" : "d-none"}`}
                    sx={{ color: setMobileTextColor() }}
                  />
                )}
              </Button>
            ) : (
              true
            )}
          </Navbar>
        </div>
        <div className="wellcomeScreen">
          <Container>
            <div
              className="text-center"
              style={{ paddingLeft: "24px", paddingRight: "24px" }}
            >
              <h1
                className="mb-2 head-font"
                style={{ color: setMobileTextColor() }}
              >
                {venueName}
              </h1>

              {!label_name && (
                <p
                  className="head-font"
                  style={{ color: setMobileTextColor() }}
                >
                  {desc}
                </p>
              )}
            </div>
          </Container>
        </div>
      </div>
      <Navbar
        className={`d-flex justify-content-between align-items-center position-fixed top-0 z-2 mobile-nav ${!isScrolled ? "d-none" : ""
          } alignByLang`}
        style={{
          width: "100%",
          margin: "auto",
          backgroundColor: setMobileBackColor(),
          width: width,
        }}
      >
        {!label_name ? (
          <Button sx={{ color: setMobileTextColor() }} onClick={openBar}>
            <MenuOutlinedIcon />
          </Button>
        ) : (
          <Button disabled></Button>
        )}

        <Navbar.Brand className="text-center m-0">
          <p
            className="mb-1 text-center sub-font"
            style={{ color: setMobileTextColor() }}
          >
            {venueName}
          </p>
          <p
            className="mb-1 text-center sub-font"
            style={{ color: setMobileTextColor() }}
          >
            {label_name && (
              <Badge
                style={{
                  borderRadius: "8px",
                }}
                className={`outofinstock-badge-dish-style  font-size-14 sub-font m-1`}
              >
                {t(label_name)}
              </Badge>
            )}
          </p>
        </Navbar.Brand>

        {params.get("section") != 0 ? (
          <Button
            onClick={handleParent}
            style={{ color: setMobileTextColor() }}
          >


            {params.get("lang") === "ar" || params.get("lang") === "fa" ? (
              <ArrowBackOutlinedIcon
                className={`${params.get("section") != 0 ? "" : "d-none"}`}
                sx={{ color: setMobileTextColor() }}
              />
            ) : (
              <ArrowForwardOutlined
                className={`${params.get("section") != 0 ? "" : "d-none"}`}
                sx={{ color: setMobileTextColor() }}
              />
            )}
          </Button>
        ) : (
          <Button
            onClick={handleParent}
            style={{ color: setMobileTextColor() }}
            disabled
          ></Button>
        )}
      </Navbar>
    </>
  );
};

export default TopNav;
